// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__10EK1","unreadBadge":"styles_unreadBadge__1CiBi","modalContent":"styles_modalContent__mhrxx","modal":"styles_modal__jW_Lf"};